<template>
  <div>
    <h1 class="has-text-weight-bold is-size-5 pb-4">{{ $t('Latest Blog') }}</h1>
    <div v-if="blogList.length">
      <div
        v-for="(blog, index) in blogList"
        :key="index"
        class="is-flex m-d-grid-752 gap-1 pa-4 mb-4 rounded-10 flex-overflow-list"
      >
        <img
          class="mx-auto image pointer border-radius-6px object-fit-cover outline mx-auto"
          :src="blog.image"
          @click="openDetailPage(blog.slug)"
        />
        <div class="pa-0 is-full-width content">
          <div
            class="is-size-4 pointer title"
            :title="blog.title"
            @click="openDetailPage(blog.slug)"
          >
            {{ blog.title }}
          </div>
          <div class="subtitle is-7 has-text-grey my-2">
            {{ $options.getHumanizeDate(blog.created_at) }}
          </div>
          <div class="is-size-7 has-text-justified line-clamp">
            {{ blog.excerpt || '' }}
          </div>
          <button
            class="ml-auto pointer has-text-weight-bold text-orange py-1 px-2 outline has-background-white border-yellow outline rounded-10 mt-2"
            @click="openDetailPage(blog.slug)"
          >
            {{ $t('Read More') }}
          </button>
        </div>
      </div>
      <div>
        <pagination
          v-model="paginationController.page"
          :page-size="paginationController.itemsPerPage"
          :collection-name="'BlogList'"
          @scroll="$emit('scroll')"
        ></pagination>
      </div>
    </div>

    <div v-else class="columns">
      <div class="column">
        <vue-no-data :loading="loading"></vue-no-data>
      </div>
    </div>
  </div>
</template>
<script>
import { getResouceUrl } from '@/helpers/utils/searchUtils'
import Pagination from '@/components/Commons/Pagination'
import VueNoData from '@/components/Commons/VueNoData'
import { getHumanizeDate } from '@/helpers/utils/date'
import { truncateChars } from '@/helpers/utils/common'
export default {
  getHumanizeDate,
  truncateChars,
  components: { VueNoData, Pagination },
  data() {
    return {
      filterFields: {},
      paginationController: {
        page: 1,
        itemsPerPage: 5
      },
      loading: false
    }
  },
  computed: {
    blogList() {
      return (
        this.get(this.$store.state.collection.collectionResponses, [
          'BlogList',
          'results'
        ]) || []
      )
    }
  },
  watch: {
    'paginationController.page': {
      handler(newVal) {
        this.$set(
          this.filterFields,
          'offset',
          this.paginationController.itemsPerPage * (newVal - 1)
        )

        this.$set(
          this.filterFields,
          'limit',
          this.paginationController.itemsPerPage
        )

        this.getBlogs()
      }
    },
    '$route.query.archive': {
      handler(val) {
        this.filterFields.archive = val
      },
      immediate: true
    },
    '$route.params.slug': {
      handler(val) {
        if (
          [`/en/blog/category/${val}`, `/blog/category/${val}`].includes(
            this.$route.path
          )
        ) {
          this.filterFields.categories = val
        } else if (
          [`/en/blog/tag/${val}`, `/blog/tag/${val}`].includes(this.$route.path)
        ) {
          this.filterFields.tags = val
        }
      },
      immediate: true
    },
    filterFields: {
      handler(val) {
        this.getBlogs()
      },
      deep: true
    }
  },
  mounted() {
    this.filterFields = {
      ...this.filterFields,
      ...{
        limit: this.paginationController.itemsPerPage
      }
    }
    this.getBlogs()
  },
  methods: {
    getBlogs() {
      this.loading = true
      const contentUrl = `/api/v1/blogs/`
      const resourceUrl = getResouceUrl(contentUrl, this.filterFields)
      this.$axios
        .get(resourceUrl)
        .then(({ data }) => {
          this.$store.commit('collection/setCollectionData', ['BlogList', data])
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetailPage(slug) {
      this.$router.push(
        this.localePath({
          name: 'blog-detail-slug',
          params: { slug }
        })
      )
    }
  }
}
</script>
